<template>
    <div class="box">
        <div class="navBar">
            <div class="btn" v-for="(item, index) in options" :key="index" :class="{ actived: index == currentIndex }"
                @click="change(index)">{{ item }}</div>
        </div>
        <div class="navBar" v-if="articleNum == 30">
            <div class="btn" v-for="(item, index) in options1" :key="index" :class="{ actived: index == currentIndex1 }"
                @click="change1(index)">{{ item }}</div>
        </div>
        <div class="itemBox" v-for="(item, index) in dataList" :key="index" @click="jumpToDetail(item.infoId)">
            <img :src="item.backImg" alt=""
                style="width: 96px; height: 96px; border-radius: 4px; margin-left: 16px; object-fit: cover;">
            <div class="rightBox">
                <div class="titleBar">
                    <img src="~assets/smallArticleTitle.svg" alt="">
                    <div class="title">{{ item.title }}</div>
                </div>
                <!-- <div class="infoBox">{{ item.infoContent }}</div> -->
                <div class="infoBox">{{ item.infoContent[0] }}</div>
                <div class="detailBox">
                    <div style="display: flex; max-width: 200px;">
                        <div style="margin-right: 8px;">{{ item.doctorName }}</div>
                        <div class="doctorTitle">{{ item.doctorTitle }}</div>
                    </div>
                    <div style="display: flex;">
                        <div style="margin-right: 16px;">{{ item.browse }}次查看</div>
                        <div>{{ item.startTime }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
  getMediaInfoList,
  getMediaInfoList1,
  getMediaInfoList2,
  getMediaInfoList3
} from 'network/getData'
import newFormateDate from 'util/newFormateDate'

export default {
    name: 'articleCom',
    props: {
        articleNum: {
            type: Number
        }
    },
    data() {
        return {
            dataList: [],
            options: ['最新', '最热', '精神科', '心理咨询科'],
            options1: ['全部', '抑郁性神经症', '产后抑郁症', '躯体疾病所致精神障碍', '性指向障碍', '焦虑症', '心理咨询'],
            currentIndex: 0,
            currentIndex1: 0
        }
    },
    methods: {
        async getMediaInfoListdata(filterCondition, row, page, type) {
            try {
                const result = await getMediaInfoList(filterCondition, row, page, type)
                this.dataList = result.data.data;
                for (var i = 0; i < this.dataList.length; i++) {
                    var d = new Date(this.dataList[i].startTime)
                    this.dataList[i].startTime = newFormateDate(d)
                    this.dataList[i].infoContent = JSON.parse(this.dataList[i].infoContent)
                }
            } catch (error) {
                // console.log(error)
            }
        },
        jumpToDetail(e) {
            this.$router.push({ path: '/mobVideoCenterArticleDel', query: { articleId: e } })
        },
        async change(e) {
            this.currentIndex = e
            await this.requestData();
        },
        async change1(e) {
            this.currentIndex1 = e
            await this.requestData();
        },
        async requestData() {
            var result = []
            if (this.currentIndex1 == 0) {
                if (this.currentIndex < 2) {
                    if (this.currentIndex == 0) {
                        result = await getMediaInfoList1('latest', this.articleNum, 1, 'article')
                    }
                    else if (this.currentIndex == 1) {
                        result = await getMediaInfoList1('popular', this.articleNum, 1, 'article')
                    }
                }
                else if (this.currentIndex >= 2) {
                    result = await getMediaInfoList1('latest', this.articleNum, 1, 'article', this.options[this.currentIndex])
                }
            }
            else if (this.currentIndex1 != 0) {
                if (this.currentIndex < 2) {
                    if (this.currentIndex == 0) {
                        result = await getMediaInfoList3('latest', this.articleNum, 1, 'article', this.options1[this.currentIndex1])
                    }
                    else if (this.currentIndex == 1) {
                        result = await getMediaInfoList3('popular', this.articleNum, 1, 'article', this.options1[this.currentIndex1])
                    }
                }
                else if (this.currentIndex >= 2) {
                    result = await getMediaInfoList2('latest', this.articleNum, 1, 'article', this.options[this.currentIndex], this.options1[this.currentIndex1])
                }
            }
            this.dataList = result.data.data;
            for (var i = 0; i < this.dataList.length; i++) {
                var d = new Date(this.dataList[i].startTime)
                this.dataList[i].startTime = newFormateDate(d)
                this.dataList[i].infoContent = JSON.parse(this.dataList[i].infoContent)
            }
        }
    },
    mounted() {
        this.getMediaInfoListdata('latest', this.articleNum, 1, 'article')
    }
}
</script>
<style scoped>
.box {
    width: 1030px;
    height: auto;
    margin: 0 auto;
}

.itemBox {
    display: inline-flex;
    align-items: center;
    width: 495px;
    height: 120px;
    background: #F9F9FA;
    border-radius: 12px;
    margin-right: 20px;
    margin-bottom: 16px;
    cursor: pointer;
}

/* .itemBox:nth-child(even) {
    margin-right: 0;
} */

.rightBox {
    display: inline-block;
    width: 347px;
    height: 96px;
    margin-left: 16px;
}

.titleBar {
    display: flex;
    width: 100%;
    height: 24px;
    align-items: center;
}

.title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #262626;
    margin-left: 9px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.infoBox {
    width: 100%;
    margin-top: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #8C8C8C;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.detailBox {
    width: 100%;
    margin-top: 8px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #595959;
}

.navBar {
    width: auto;
    height: 26px;
    margin-bottom: 26px;
}

.btn {
    width: auto;
    ;
    height: 24px;
    padding: 0 15px;
    display: inline-block;
    margin-right: 20px;
    border: 1px solid #fff;
    border-radius: 20px;
    color: #262626;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
}

.actived {
    border: 1px solid #0089CE;
    color: #0089CE;
}

.doctorTitle {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>